export { default } from './table';
